import styles from "./styles/Inputs.module.css";

export const TextInput = ({
  type,
  label,
  value,
  name,
  onChange,
  disabled,
  error,
  errorMsg
}) => {
  const inputStyles = `
    ${styles.input}
    ${disabled ? styles.disabled : ""}
    ${error ? styles.error : ""}
  `;

  const labelStyles = `
    ${styles.label}
    ${error ? styles.errorLabel : ""}
  `;

  return (
    <div className={styles.container}>
      <label className={labelStyles} htmlFor={name}>{label}</label>
      <input
        id={name}
        className={inputStyles}
        type={type}
        name={name}
        placeholder={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      {error && (
        <p className={styles.errorMsg}>
          {errorMsg ? errorMsg : "Error"}
        </p>
      )}
    </div>
  )
}